import { FormattedMessage } from 'react-intl';
import { ProductCertificateType } from './product-certificate-type';
import { ProductLineItemProps } from './types';

export const ProductLineItem = ({
  item: { name: title, variant },
}: ProductLineItemProps) => (
  <div className="product-line-item">
    <div>
      <h3 className="m-0 h5">
        <FormattedMessage
          id="payment.form.cart.item.title"
          defaultMessage="{title}"
          description="Title for the Product Cart Item"
          values={{ title }}
        />
      </h3>
      <ProductCertificateType certificateType={variant?.attributes?.mode} />
    </div>
  </div>
);
